import { render, staticRenderFns } from "./CoverUploader.vue?vue&type=template&id=51b26bb4&"
import script from "./CoverUploader.vue?vue&type=script&lang=ts&"
export * from "./CoverUploader.vue?vue&type=script&lang=ts&"
import style0 from "./CoverUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports